import { handleApiError } from "@/lib/handleError";
import { Vehicle } from "../types/vehicle.types";

export const fetchVehicles = async (
  make: string, 
  model: string, 
  year: string
): Promise<Vehicle[] | null> => {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/vehicles?make=${make}&model=${model}&year=${year}`);

  const errorResult = await handleApiError(res);
  if (errorResult === null) return null;

  return res.json();
};
